import { getSystemList } from "@iewcasia/Services/OrderService";
import setFieldValue from "@iewcasia/Store/Handlers/RfqRequestQuote/SetFieldValue";
import { CustomActions, CustomState } from "@iewcasia/Store/Reducers";
import {
    getRfqFormCheckboxBuilt,
    getRfqFormHintTextBuilt,
    getRfqFormItemsBuilt,
    getRfqFormLabelBuilt,
    OwnProps,
    requestQuoteStyles,
    setRequestFormEffects,
    validateFieldBy,
} from "@iewcasia/Widgets/RfqRequestQuote/FormBaseComponent";
import { RequestQuoteFormContext } from "@iewcasia/Widgets/RfqRequestQuote/RequestForm";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Select from "@insite/mobius/Select";
import * as React from "react";
import { connect, DispatchProp, ResolveThunks } from "react-redux";

const styles = {
    ...requestQuoteStyles.selectFields,
};

const mapStateToProps = (customState: CustomState) => ({
    country: customState.customRequestQuoteForm.fieldValues.country,
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    DispatchProp<CustomActions>;

const CountryWidget: React.FC<Props> = ({ fields: widgetFields, country, setFieldValue: widgetSetFieldValue }) => {
    const { label, hintText, isRequired, items } = widgetFields;
    const [countryOptions, setCountryOptions] = React.useState([]);
    const [fieldErrorMessage, setFieldErrorMessage] = React.useState("");
    const { countries } = React.useContext(RequestQuoteFormContext) as any;

    setRequestFormEffects(isRequired, country, "country", () =>
        validateFieldBy(isRequired, label, country, setFieldErrorMessage),
    );

    const fieldChangeHandler = (event: React.ChangeEvent<HTMLSelectElement>) => {
        widgetSetFieldValue({ key: "country", value: event.target.value });
    };

    const getCountryOptions = () => {
        setCountryOptions(countries?.map?.((x: any) => ({ label: x.name, value: x.name })) || []);
    }

    React.useEffect(() => {
        getCountryOptions();
    }, [countries]);

    return (
        <Select
            {...styles}
            label={label}
            required={isRequired}
            value={country || ""}
            error={fieldErrorMessage}
            onChange={fieldChangeHandler}
            placeholder={hintText || ""}
        >
            <option value="" {...(isRequired && { disabled: true })}>
                {translate(hintText)}
            </option>
            {countryOptions.map((country: any) => (
                <option key={country.value} value={country.name}>
                    {country.label}
                </option>
            ))}
        </Select>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(CountryWidget),
    definition: {
        group: "Request a Quote Form" as any,
        icon: "FormField",
        fieldDefinitions: [
            getRfqFormLabelBuilt("Country"),
            getRfqFormHintTextBuilt("Please select"),
            getRfqFormCheckboxBuilt(),
        ],
    },
};

export default widgetModule;
